import {
    atom,
} from 'recoil';

export const tickets = atom({
    key: 'tickets',
    default: [],
});

export const usersState = atom({
    key: 'users',
    default: [],
});
export const notificationState = atom({
    key: 'notification',
    default: [],
});

export const settoriState = atom({
    key: 'settori',
    default: [],
});
